import { FETCH_REVIEWS_LIST } from '../actions/types'

export interface ReviewsListItem {
  id: number
  reservation_id?: string
  cleanliness?: number
  value?: number
  accuracy?: number
  accessibility?: number
  neighborhood?: number
  host?: number
  positives?: string[]
  negatives?: string[]
  suggest?: number
  show_family_only?: number
  description?: string
  living_city?: string
  confirmed?: number
  operator_status?: string
  images?: {
    id?: number
    review_id?: number
    reservation_id?: number
    path?: string
    thumbnail_path?: string
    caption?: null
    created_at?: string
    updated_at?: string
  }[]
  checkin?: string
  checkout?: string
  user?: {
    name?: string
    family?: string
    picture?: string
  }
  comment?: {
    id?: number
    user_id?: number
    review_id?: number
    comment?: string
    confirmed?: number
    created_at?: string
    updated_at?: string
  }
}

interface ReviewsListState {
  data: {
    house?: {
      id?: number
      title?: string
      type?: string
      city?: string
      province?: string
      cover_photo?: string
      review_count?: number
      rank?: number
    }
    reviews?: ReviewsListItem[]
  }
  loading: boolean
}

export const initialReviewsList = {
  data: {
    house: {},
    reivews: [],
  },
  loading: true,
}

export interface ReviewsListProps extends ReviewsListState {
  type: string
}

export const reviewsList = (
  state: ReviewsListState = initialReviewsList,
  action: ReviewsListProps,
) => {
  switch (action.type) {
    case FETCH_REVIEWS_LIST:
      return { data: action.data, loading: action.loading }

    default:
      return state
  }
}
